<ng-container *ngIf="isStatusPlotsLoaded; else loadingSpinner">
  <div class="vehicle-status new-replay-enabled" *ngIf="(statusPanelItems$ | async).length > 0; else noVehiclesSelected">
    <ng-container *uiScroll="let item of statusPanelItems; let isLast = last">
      <ng-container *ngTemplateOutlet="panelItems; context: { item: item.item }"></ng-container>
    </ng-container>
  </div>
</ng-container>

<ng-template #loadingSpinner>
  <div class="vehicle-status-spinner">
    <mat-spinner [diameter]="48"></mat-spinner>
  </div>
</ng-template>

<ng-template #noVehiclesSelected>
  <fm-no-vehicle-selected
    [vehicleStatusFilterSelected]="vehicleStatusFilterSelected$ | async"
    [hasFleetConnected]="hasFleetConnected"
    [hasFleetSelected]="hasFleetSelected"
    displayMessage="No vehicles selected"
    i18n-displayMessage="@@S_NOVEHSELECTED"
    (selectVehiclesClicked)="onSelectVehiclesClicked()"
  ></fm-no-vehicle-selected>
</ng-template>

<ng-template #panelItems let-item="item">
  <ng-container [ngSwitch]="item.type">
    <fm-vehicle-status-item
      *ngSwitchCase="EPlotType.vehicle"
      a7s-id="vehicle-panel-vehicle-item"
      [attr.id]="getVehicleIdSelector(item?.id)"
      [vehicle]="item"
      [isHighlighted]="highlightedVehicles.has(item.id)"
      [vehiclePlotsTimer]="getVehiclePlotTimer(item.id) | async"
      [vehicleStatusInfo]="vehicleStatusInfo$ | async"
      [vehicleFuelType]="(vehicleFuelTypes$ | async).get(item.id)"
      [userSettings]="userSettings$ | async"
      [isEVChangesEnabled]="true"
      [isSelected]="selectedItemId === item.id"
      [vehicleHealthStatus]="getVehicleHealthStatus(item.id) | async"
      class="vehicle-status__vehicle"
      (click)="onVehicleClick(item)"
      (contextmenu)="onVehicleRightClick($event, item)"
      (contextMenuClicked)="openVehicleContextMenuClick($event, item)"
      (mouseenter)="onVehicleMouseEnter(item)"
      (mouseleave)="onVehicleMouseLeave()"
    ></fm-vehicle-status-item>

    <fm-vehicle-status-item
      *ngSwitchCase="EPlotType.poweredAsset"
      a7s-id="vehicle-panel-powered-asset-item"
      [attr.id]="getVehicleIdSelector(item?.id)"
      [vehicle]="item"
      [isHighlighted]="highlightedVehicles.has(item.id)"
      [vehiclePlotsTimer]="getVehiclePlotTimer(item.id) | async"
      [vehicleStatusInfo]="vehicleStatusInfo$ | async"
      [vehicleFuelType]="(vehicleFuelTypes$ | async).get(item.id)"
      [isSelected]="selectedItemId === item.id"
      [vehicleHealthStatus]="getVehicleHealthStatus(item.id) | async"
      class="vehicle-status__powered-asset"
      (click)="onVehicleClick(item)"
      (contextmenu)="onVehicleRightClick($event, item)"
      (contextMenuClicked)="openVehicleContextMenuClick($event, item)"
      (mouseenter)="onVehicleMouseEnter(item)"
      (mouseleave)="onVehicleMouseLeave()"
    ></fm-vehicle-status-item>

    <fm-asset-status-item
      *ngSwitchCase="EPlotType.asset"
      a7s-id="vehicle-panel-asset-item"
      [attr.id]="getAssetIdSelector(item?.id)"
      [asset]="item"
      [isSelected]="selectedItemId === item.id"
      [vehicleStatusInfo]="vehicleStatusInfo$ | async"
      [vehicleHealthStatus]="getVehicleHealthStatus(item.id) | async"
      class="vehicle-status__vehicle"
      (click)="onAssetClick(item)"
      (contextmenu)="onAssetRightClick($event, item)"
      (contextMenuClicked)="openAssetContextMenuClick($event, item)"
      (mouseenter)="onAssetMouseEnter(item)"
      (mouseleave)="onAssetMouseLeave()"
    ></fm-asset-status-item>

    <hr [class.last]="isLast" class="vehicle-status-item-separator" />
  </ng-container>
</ng-template>
